import { Chip, styled } from "@mui/material";

export const StyledChip = styled(Chip)(() => ({
    fontSize: '12px',
    borderColor: '#97D9B7',
    backgroundColor: '#F3FBF7',
    color: '#068745',
    height: '18px',
    '& .MuiChip-icon': {
        fontSize: '12px',
    }
}));
